import { useOffline } from '@/contexts/OfflineContext';
import { WifiOff, RefreshCw, CloudOff, Check } from 'lucide-react';

export default function OfflineBanner() {
  const { isOnline, pendingCount, isSyncing, syncProgress, failedCount, unownedCount, storageError, triggerSync } = useOffline();

  if (storageError) return <div role="alert" className="bg-amber-100 text-amber-950 px-4 py-3 text-sm">{storageError}</div>;
  if (failedCount > 0) return <div role="status" className="bg-amber-100 text-amber-950 px-4 py-2 flex items-center justify-center gap-3 text-sm">{failedCount} saved log{failedCount === 1 ? '' : 's'} need attention. Your entries remain on this device.<button disabled={!isOnline || isSyncing} onClick={() => void triggerSync()} className="min-h-11 underline font-semibold disabled:opacity-50">Retry upload</button></div>;
  if (unownedCount > 0) return <div role="status" className="bg-amber-100 text-amber-950 px-4 py-2 text-sm">Older saved entries have no verified account. They are preserved on this device and will not upload automatically. Contact support before clearing browser data.</div>;
  // Syncing banner
  if (isSyncing && syncProgress) {
    return (
      <div className="bg-blue-500 text-white px-4 py-2 flex items-center justify-center gap-2 text-xs font-semibold">
        <RefreshCw size={13} className="animate-spin" />
        Syncing {syncProgress.current}/{syncProgress.total} pending logs...
      </div>
    );
  }

  // Offline with pending items
  if (!isOnline && pendingCount > 0) {
    return (
      <div className="bg-amber-500 text-white px-4 py-2 flex items-center justify-center gap-2 text-xs font-semibold">
        <CloudOff size={13} />
        Offline — {pendingCount} log{pendingCount !== 1 ? 's' : ''} will sync when connected
      </div>
    );
  }

  // Offline, nothing pending
  if (!isOnline) {
    return (
      <div className="bg-amber-500 text-white px-4 py-2 flex items-center justify-center gap-2 text-xs font-semibold">
        <WifiOff size={13} />
        You're offline — logs will be saved locally
      </div>
    );
  }

  // Online with pending (shouldn't happen long, auto-sync fires)
  if (pendingCount > 0) {
    return (
      <div className="bg-blue-500 text-white px-4 py-2 flex items-center justify-center gap-2 text-xs font-semibold">
        <RefreshCw size={13} className="animate-spin" />
        Saved on this device — {pendingCount} pending log{pendingCount !== 1 ? 's' : ''}...
      </div>
    );
  }

  // All good — don't show anything
  return null;
}
